import { convertFigmaTypo } from 'themes/convertFigmaTypo';
import { headingFontFamily, mainFontFamily } from 'themes/default/typo';
import figmaTypo from 'themes/partners/nytimes/json/typo.json';

export const typo = convertFigmaTypo(figmaTypo, headingFontFamily, mainFontFamily);
